
import { Card, CardContent } from '@/components/ui/card';

interface Advisor {
  name: string;
  title: string;
  logos: string[];
}

const advisors: Advisor[] = [
  {
    name: "Saurabh Nigam",
    title: "Award winning HR Leader",
    logos: ["/lovable-uploads/68024710-3e67-4a2b-866d-21d0cd49b4b0.png", "/lovable-uploads/32334656-9272-41cd-b728-c0ce02ee72f0.png"]
  }
];

export const AdvisorsSection = () => {
  return (
    <section className="mb-20">
      <h2 className="text-3xl font-bold text-brand-darkgrey text-center mb-12">Our Advisors</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {advisors.map((advisor) => (
          <Card key={advisor.name} className="hover:shadow-md transition-shadow duration-300">
            <CardContent className="p-4">
              <h3 className="font-semibold text-lg text-brand-darkgrey mb-2">{advisor.name}</h3>
              <p className="text-brand-grey mb-4">{advisor.title}</p>
              <div className="flex gap-4 items-center">
                {advisor.logos.map((logo, index) => (
                  <img
                    key={index}
                    src={logo}
                    alt={`${advisor.name} association`}
                    className="h-8 object-contain"
                  />
                ))}
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
    </section>
  );
};
